import React, { useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { COLORS, FlexView, Row } from '@cuemath/comps';
import { Button as WCButton, Text } from '@cuemath/web-comps';

import { closeModal } from 'actions/modal';
import Search from 'modules/list/new-search-bar';

const Wrapper = styled(FlexView)`
  padding: 24px 24px 0;
  gap: 24px;
  margin-bottom: 116px;
`;

const HeaderCard = styled(FlexView)`
  gap: 8px;
`;

const TransferStudentCard = styled(FlexView)`
  gap: 8px;
`;

const ButtonWrapper = styled(Row)`
  gap: 16px;
  padding: 16px 24px 24px;
  border-top: 1px solid ${COLORS.GHOST};
`;

const Button = styled(WCButton)`
  width: ${({ width }) => width || '128px'};
`;

const StudentTransferInitiateForm = () => {
  const [transferStudentId, setTransferStudentId] = useState('');
  const [transferTeacherId, setTransferTeacherId] = useState('');

  const dispatch = useDispatch();
  const history = useHistory();

  const onCancel = () => {
    dispatch(closeModal());
  };

  const onProceedWithTransfer = () => {
    if (transferStudentId) {
      window.open(`/students/${transferStudentId}?student_tab=student-transfer`);
      onCancel();
    } else if (transferTeacherId) {
      history.push(`/student-transfer/${transferTeacherId}`);
    }
  };

  const onStudentSearch = searchVal => {
    setTransferStudentId(searchVal);

    if (transferTeacherId) {
      setTransferTeacherId('');
    }
  };

  const onTeacherSearch = searchVal => {
    setTransferTeacherId(searchVal);

    if (transferStudentId) {
      setTransferStudentId('');
    }
  };

  return (
    <>
      <Wrapper>
        <HeaderCard>
          <Text variant="h4">Initiate student transfer</Text>
          <Text variant="body2">
            Choose between transferring single student vs transferring all students of a
            teacher
          </Text>
        </HeaderCard>

        <TransferStudentCard>
          <Text variant="cta2">Transfer the below student</Text>
          <Search
            width="100%"
            placeholder="Search a student by ID"
            customSearchData={{
              onChange: onStudentSearch,
              searchValue: transferStudentId,
            }}
          />
        </TransferStudentCard>

        <Text variant="eyebrow2">OR</Text>

        <Text variant="cta2" color={COLORS.RED_SHADE}>
          Bulk transfer will be available in short time. Hold tight!
        </Text>
        {/* //* Enable this during SDT V2 release.*/}
        {false && (
          <TransferStudentCard>
            <Text variant="cta2">Bulk transfer all students of the teacher</Text>
            <Search
              width="100%"
              placeholder="Search a teacher by number or ID"
              customSearchData={{
                onChange: onTeacherSearch,
                searchValue: transferTeacherId,
              }}
            />
          </TransferStudentCard>
        )}
      </Wrapper>
      <ButtonWrapper nowrap alignItems="center">
        <Button label="Cancel" backgroundColor={COLORS.WHITE} onClick={onCancel} />
        <Button
          width="320px"
          label="Let's Proceed"
          isDisabled={!(transferStudentId || transferTeacherId)}
          onClick={onProceedWithTransfer}
        />
      </ButtonWrapper>
    </>
  );
};

export default StudentTransferInitiateForm;
